import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { faSnowflake } from "@fortawesome/free-regular-svg-icons";

library.add(faUserSecret, faSnowflake);
